import React from "react";
import {
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Bar,
  ResponsiveContainer,
  LabelList,
} from "recharts";

function WebsiteHits({ data }) {
  let sum = 0;
  data?.forEach((item) => {
    sum += item.value;
  });

  return (
    <div className="website-hits-card ">
      <div className="website-hits-header">
        {/* Title Section */}
        <div className="website-hits-title">
          <h1>Website Visitors</h1>
        </div>

        {/* Total Hits Section */}
        <div className="website-hits-total">
          <h1>Total Visits This Week</h1>
          <p className="total-hits-count">{sum}</p>
        </div>
      </div>

      {/* Chart Section */}
      <ResponsiveContainer height="80%">
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
        >
          {/* Define the gradient */}
          <defs>
            <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#383D8D" />
              <stop offset="100%" stopColor="#A42066" />
            </linearGradient>
          </defs>

          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            label={{
              value: "Days of the Week",
              position: "bottom",
              offset: -4,
            }}
          />
          <YAxis dataKey="value" />

          {/* Apply the gradient here */}
          <Bar dataKey="value" fill="url(#barGradient)" radius={[12, 12, 0, 0]}>
            <LabelList dataKey="value" position="insideTop" fill="#FFFFFF" />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default WebsiteHits;
